import { ImageField } from '@prismicio/client';
import Image from 'next/image';
import Heading from '../Heading/Heading';
import styles from './reviews.module.scss';

export type Review = {
    title: string;
    content: string;
    author: {
        name: string;
        image: ImageField;
    };
};

type ReviewsCardProps = {
    review: Review;
};

const ReviewsCard = ({ review }: ReviewsCardProps) => (
    <article className="flex flex-col justify-center h-full pointer-events-none">
        <header>
            <Heading level="h3" tag="p" className="mb-4">
                {review.title}
            </Heading>
        </header>
        <section className="pb-8">{review.content}</section>
        {review?.author?.image?.url && (
            <picture className={styles['card-image-wrapper']}>
                <Image
                    src={review.author.image.url}
                    width={review.author.image.dimensions?.width}
                    height={review.author.image.dimensions?.height}
                    alt={review.author.image.alt ?? 'image'}
                />
            </picture>
        )}
        <footer className="mt-auto">{review.author.name}</footer>
    </article>
);

export default ReviewsCard;
